import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { reduce, merge, omit, get, map, isNil, isEmpty, trim } from 'lodash';
import * as jobRequestApi from '../../../../redux/actionCreators/async/jobrequests';
import InfoModal from '../../../../common/components/f_InfoModal';
import TextField from '../../../../common/components/c_TextField';
import SubmissionBar from '../../SubmissionBar';
import * as companyStore from '../../../../redux/actionCreators/sync/companies';

const ACTIVE_ACCOUNT = 4;

@connect((store) => {
	return {
		staticData: store.staticData,
		user: store.user,
		jobRequest: store.jobRequest,
		company: store.company,
    labels: store.labels.jobRequest.authorize || {}
	};
})
export default class JobRequestAuthorize extends Component {

	static propTypes = {
		staticData: PropTypes.object.isRequired,
		user: PropTypes.object,
		jobRequest: PropTypes.object,
		completed: PropTypes.object,
		params: PropTypes.object,
		dispatch: PropTypes.func.isRequired,
		company: PropTypes.object.isRequired,
	}

	constructor(props, context) {
		super(props, context);

		this.state = {
			isDirty: false,
			showSuccess: false,
			submitted: false
		};

	}

	closeModal() {
		this.setState(merge(this.state, {showSuccess: false}));
	}

	handleBack = () => {
		this.props.dispatch(push(`/client/jobrequest/${this.props.jobRequest.id||0}/addcontact`));
	}

	handleSubmit = () => {

		const company =  this.props.company;
		const updateCompanyStatus = () => this.props.dispatch(companyStore.updateCompany({...company, companyStatus: ACTIVE_ACCOUNT}));
		const authorizeJR = (userId, jobId, success) => this.props.dispatch(jobRequestApi.authorizeJobRequest(userId, jobId, {success}));

		authorizeJR(this.props.user.id, this.props.jobRequest.id, () => {
			this.setState({showSuccess: true, submitted: true});
			updateCompanyStatus();
		});

	}

	signature = () => {
		return [get(this.props, 'user.firstName'), get(this.props, 'user.middleName'), get(this.props, 'user.lastName')]
							.map(trim)
							.filter(part => !isNil(part) && !isEmpty(part))
							.join(' ');
	}

	handleChange(event) {
		const regexp = new RegExp(this.signature(), 'gi');
		const errorText = !regexp.test(event.target.value) ? 'Please sign with the name provided.' : undefined;

		this.setState({errorText, isDirty: true});
  }

	handleUI(prop, label) {

		if(this.props.jobRequest.dateAuthorized && prop === 'signature') {
			return {
				value: this.signature(),
				ref: prop,
				'data-id': prop,
				errorText: this.state.errorText,
				floatingLabelText: label || null
			};
		}

		return {
			ref: prop,
			'data-id': prop,
			errorText: this.state.errorText,
			floatingLabelText: label || null
		};
  }

render() {

	const sectionNames = {
		description: 'Job Description',
		adddocuments: 'Add Documents',
		skills: 'Skills',
		summary: 'Summary Of Skills',
		workschedule: 'Work Schedule',

	};

	const sections = omit(this.props.completed, ['addcontact', 'adddocuments']);
	const completed = map(sections, (value, key) => ({name: sectionNames[key], valid: value}));
	const isCompleted = reduce(completed, (acc, section) => acc && section.valid, true);
	const companyStatus = get(this.props.company, 'companyStatus');
	const isActiveAccount = companyStatus === ACTIVE_ACCOUNT;
	const canSubmit = isCompleted && this.state.isDirty && !this.state.submitted && !this.state.errorText;
	const {
		successfulInitial = '',
		successfulAdditional = ''
	} = get(this.props, 'labels', {});

	const successText = isActiveAccount ? successfulAdditional : successfulInitial;

	return (
		<div className='job-request-authorize'>

				{
					this.state.showSuccess &&
						<InfoModal
							cancelFunc={this.closeModal.bind(this)}
							buttonLabel={'close'}
							transitionFunc={() => this.props.dispatch(push('/client/jobrequesthistory'))}
							text={successText}
						/>
				}

				<h1> Terms and Conditions, Authorize & Submit</h1>
				<div className='terms-section' dangerouslySetInnerHTML={{__html: this.props.labels.authorizeText}}></div>


			{!isCompleted && !this.state.submitted && <div className='invalid-sections'>
				The following section(s) have not been completed. Please complete in order to authorize and submit.

				<ul className='sections'>
				{
					completed
						.filter((section) => section.valid === false)
						.map((section) =>  <li>{section.name}</li>)
				}
				</ul>
			</div>}

				<p className='signature-label'>
					By typing your name in the Signature, you are agreeing to the Terms and Conditions and authorizing this Job Request.
				</p>

				<TextField className='center-column-1 terms-signature'
					{...this.handleUI('signature', 'Signature')}
					onChange = {this.handleChange.bind(this)}
					disabled={this.props.jobRequest.dateAuthorized}
					subText={this.signature()}
				/>

				<TextField
					className='center-column-1'
					disabled
					defaultValue = {this.props.jobRequest.dateAuthorized ? new Date(this.props.jobRequest.dateAuthorized).toDateString() : new Date().toDateString()}
					floatingLabelText = 'Date Signed'
					data-id = 'Date Signed'
				/>

				{ !this.props.jobRequest.dateAuthorized
					&&
					<SubmissionBar
						onBack={this.handleBack}
						onNext={this.handleSubmit}
						onSave={null}
						submitDisabled={!canSubmit}
						hideBack={true}
						finalStep={true}
					/>
				}

		</div>
  );
 }
}



// WEBPACK FOOTER //
// ./shared/react/client/JobRequest/JobRequestAuthorize/index.js